/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ProductList } from '@msdyn365-commerce/retail-proxy';

import { QuickOrderTemplateLine } from './quick-order-template-line';

/**
 * Quick Order template class.
 */
export class QuickOrderTemplate {
    public productList: ProductList;

    public quickOrderTemplateLines: QuickOrderTemplateLine[];

    public totalLines: number;

    public constructor(productList: ProductList, quickOrderTemplateLines: QuickOrderTemplateLine[], totalLines: number) {
        this.productList = productList;
        this.quickOrderTemplateLines = quickOrderTemplateLines;
        this.totalLines = totalLines;
    }
}
